import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams  } from '@angular/common/http';

import { Observable, forkJoin } from 'rxjs';

import * as theGlobals from '../shared/globals';
import { UtilitiesService } from './utilities.service';

import { ICaseList } from '../shared/classes/case-list';
import { ICase } from '../shared/classes/case';
import { IProperty } from '../shared/classes/property';
import { IApplicant } from '../shared/classes/applicant';
import { IAgency } from '../shared/classes/agency';
//
// DTOs
import { AgencyDto } from '../application/agencies/agency.dto';
import { ApplicationCaseDto } from '../application/case/dto/application-case.dto';
import { ApplicationAgentDto } from '../application/case/dto/application-agent.dto';
import { ApplicationApplicantDto } from '../application/case/dto/application-applicant.dto';
import { ApplicationValueDto } from '../application/case/dto/application-value.dto';
import { ApplicationAssessorDto } from '../application/case/dto/application-assessor.dto';
import { ApplicationMinutesDto } from '../application/case/dto/application-minutes.dto';
import { ApplicationStatusDto } from '../application/case/dto/application-status.dto';
import { ApplicationDocumentDto } from '../application/case/dto/application-document.dto';

//
import * as appData from '../shared/appData';
import {ApplicationCaseCommentDto} from "../application/case/dto/application-comments.dto";
// import { format } from 'url';

@Injectable()
export class CaseService {

    private myUrl = theGlobals.setEnv().funcUrl;
    private myApnList = appData.apnList;


    constructor(private http: HttpClient, private utilService: UtilitiesService) {

     }

    getCaseListByYear(year: number): Observable<ICaseList[]> {
        const xUrl = this.myUrl + '/application/year/' + year;
        return this.http.get<ICaseList[]>(xUrl);
    }

    searchCase(searchType: string, searchVal: string): Observable<any> {
        const xUrl = this.myUrl + '/application/search/' + searchType + '/' + encodeURIComponent(searchVal);
        return this.http.get<any>(xUrl);
    }

    searchCaseByAlt(searchObj: any): Observable<any> {
      const xUrl = this.myUrl + '/application/search/complexcase';
      return this.http.post(xUrl, searchObj);
    }
    getApplication(applicationId: string): Observable<any> {
        const xUrl = this.myUrl + '/application/' + applicationId;
        return this.http.get<any>(xUrl);
    }

    getCase(applicationId: string): Observable<ApplicationCaseDto> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/case';
        return this.http.get<ApplicationCaseDto>(xUrl);
    }

    createCase(myApp: any, myYear: number): Observable<any> {
        const xUrl = this.myUrl + '/application/' + myYear;
        return this.http.post(xUrl, myApp);
    }
    updateCase(myApp: any, applicationId: string): Observable<any> {
        const xUrl = this.myUrl + '/application/' + applicationId;
        return this.http.put(xUrl, myApp);
    }

    backloadCase(myApp: any, caseNum: string): Observable<any> {
        const xUrl = this.myUrl + '/application/backload/' + caseNum;
        return this.http.post(xUrl, myApp);
    }
    getNewCaseNumber(newApplicationId: string): Observable<any> {
        const xUrl = this.myUrl + '/application/' + newApplicationId + '/case';
        return this.http.get<any>(xUrl);
    }

    getCaseProperty(applicationId: string): Observable<IProperty> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/property';
        return this.http.get<IProperty>(xUrl);
    }

    getCaseAssessor(applicationId: string): Observable<ApplicationAssessorDto> {
        const xUrl = this.myUrl + '/assessor/' + applicationId;
        return this.http.get<ApplicationAssessorDto>(xUrl);
    }

    getCaseMinutes(applicationId: string): Observable<ApplicationMinutesDto[]> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/minutes';
        return this.http.get<ApplicationMinutesDto[]>(xUrl);

    }
    getValueGroup(applicationId: string, groupType: string): Observable<ApplicationValueDto> {
        // types are assessor, applicant, opinion, final
        const xUrl = this.myUrl + '/application/' + applicationId + '/group/' + groupType + '/values';
        return this.http.get<ApplicationValueDto>(xUrl);
    }

    getValueCase(applicationId: string): Observable<any> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/case/values';
        return this.http.get<any>(xUrl);
    }

    getAllValues(applictionId: string): Observable<any> {
        // this function will return only ONE Observable once ALL the individual Observables have emitted results
      // tslint:disable-next-line:max-line-length
        const obsArr = [this.getValueGroup(applictionId, 'applicant'), this.getValueGroup(applictionId, 'opinion'), this.getValueGroup(applictionId, 'assessor'), this.getValueGroup(applictionId, 'final')];
        return forkJoin(obsArr);
    }

    getValuesForCases(appArray: any[]): Observable<any> {
        const obsArr = [];
        if (appArray.length === 0) { return null; }
        let appId = '';
        for (let ctr = 0; ctr < appArray.length; ctr++) {
            appId = appArray[ctr];
            obsArr.push(this.getValueCase(appId));
        }
        return forkJoin(obsArr);
    }

    getCaseApplicant(applicationId: string): Observable<ApplicationApplicantDto> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/applicant';
        return this.http.get<ApplicationApplicantDto>(xUrl);
    }

    getCaseAgent(applicationId: string): Observable<ApplicationAgentDto> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/agency';
        return this.http.get<ApplicationAgentDto>(xUrl);
    }

    getCaseStatusList(applicationId: string): Observable<any[]> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/status';
        return this.http.get<any[]>(xUrl);
    }

    // get FACTS associated w/ application
    getCaseFacts(applicationId: string): Observable<[]> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/facts';
        return this.http.get<[]>(xUrl);
    }

    // save individual Application Status
    saveCaseStatus(appStatus: ApplicationStatusDto): Observable<any> {
        let xUrl = this.myUrl + '/application/';
        if (appStatus.id < 1) {
            xUrl = xUrl +  'status/new';
            return this.http.post(xUrl, appStatus);
        }
        else {
            xUrl = xUrl + appStatus.id + '/status';
            return this.http.put(xUrl, appStatus);
        }
    }

    // save Batch of Application Statuses; uses same DTO as in SaveAppStatus, but w/ field applicationIds (instead of applicationId) filled in  - rod
    saveBatchAppStatus(appStatus: ApplicationStatusDto): Observable<any> {
        const xUrl = this.myUrl + '/application/batch/status';
        return this.http.post(xUrl, appStatus);

    }

    // DELETE Application Status
    deleteCaseStatus(appStatusId: string, applicationId: string): Observable<any> {
        let xUrl = this.myUrl + '/application/' + applicationId + '/status/' + appStatusId;
        return this.http.delete(xUrl);

    }
    // save Application valuations from specified source (applicant, assessor, opinion, final)
    saveCaseValueGroup(applicationId: string, grpType: string, grpValues: ApplicationValueDto): Observable<any> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/group/' + grpType + '/values';
        return this.http.put(xUrl, grpValues);
    }
    // get list of (non-efiled) documents associated w/ case
    getCaseDocs(applicationId: string): Observable<any[]> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/documents';
        return this.http.get<any[]>(xUrl);
    }
    // return URL to view case document
    getViewDocUrl(docId: string): string {
        // return this.myUrl +  '/document/download/' + docId; ;
        return this.myUrl +  '/application/document/' + docId + '/download' ;
    }
    getCaseDoc(docId: string): Observable<Blob>
  {
    let xUrl = this.myUrl +  '/application/document/' + docId + '/download' ;
    return this.http.get(xUrl,{ responseType: 'blob' });
  }

    // delete case document
    deleteCaseDoc(docId: string): Observable<any> {
        const xUrl = this.myUrl + '/application/document/' + docId;
        return this.http.delete(xUrl);

    }
    // save/upload document
    saveCaseDocument(applicationId: string, myFiles: any[], myDocDto: any): Observable<any> {
        this.utilService.doAudit(myFiles, 'myFiles:');
        const xUrl = this.myUrl + '/application/document/upload';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'multipart/form-data',
            })
          };
        const formData: FormData = new FormData();

        // formData.append('json', JSON.stringify(catalogacion));
        formData.append('applicationId', applicationId);
        formData.append('description', myDocDto.description);
        formData.append('descriptionOther', myDocDto.descriptionOther);
        // formData.append('caseDocMeta',myDocDto);

        for (const file of myFiles) {
            formData.append('myFile', file, file.name);
        }
        this.utilService.doAudit(formData, 'formData:');
        const headers = new HttpHeaders();
        this.utilService.doAudit(headers, 'headers');

        return this.http.post(xUrl, formData, { headers});
    }

    updateCaseComments(applicationId: string, cmt: string): any {
        // create API to update just the Case Comment field
        return 1;
    }
    // new, historical, case comments - 6/2024
    getHistCaseComments(applicationId: string): Observable<any>
    {
      const xUrl = this.myUrl + '/application/' + applicationId + '/comments';
      return this.http.get<[]>(xUrl);
    }

    addHistCaseComment(applicationId: string, cmt: ApplicationCaseCommentDto): Observable<any>
    {
      const xUrl = this.myUrl + '/application/' + applicationId + '/comment';
      return this.http.post(xUrl, cmt);
    }
    updateHistCaseComment(cmtId: string, cmt: ApplicationCaseCommentDto): Observable<any>
    {
      const xUrl = this.myUrl + '/application/comment/' + cmtId;
      return this.http.put(xUrl, cmt);

    }

    // Applicant-related methods
    deleteApplicant(applicantId: string): Observable<any> {
        const xUrl = this.myUrl + '/applicant/' + applicantId;
        return this.http.delete(xUrl);
    }
    saveApplicant(applicant: IApplicant): Observable<any> {
        let xUrl = this.myUrl + '/applicant';
        if (applicant.id < 1 ) {
            return this.http.post(xUrl, applicant);
        }
        else {
            xUrl = xUrl + '/' + applicant.id;
            return this.http.put(xUrl, applicant);
        }
    }
    getApplicant(applicantId: string): Observable<IApplicant> {
        const xUrl = this.myUrl + '/applicant/' + applicantId;
        return this.http.get<IApplicant>(xUrl);
    }
    // find Applicants with matching names
    findApplicant(applicantName: string): Observable<IApplicant[]> {
        const xUrl = this.myUrl + '/applicant/name/' + applicantName;
        return this.http.get<IApplicant[]>(xUrl);
    }
    // get list of ALL applicants on the system
    getApplicantList(): Observable<IApplicant[]> {
        const xUrl = this.myUrl + '/applicant';
        return this.http.get<IApplicant[]>(xUrl);

    }

    // END of Applicant-related methods
    //
    // Agency-related methods
    getAgencyList(): Observable<AgencyDto[]> {
        const xUrl = this.myUrl + '/agency';
        return this.http.get<AgencyDto[]>(xUrl);
    }
    getAgency(agencyId: string): Observable<AgencyDto> {
        const xUrl = this.myUrl + '/agency/' + agencyId;
        return this.http.get<AgencyDto>(xUrl);
    }
    deleteAgency(agencyId: string): Observable<any> {
        const xUrl = this.myUrl + '/agency/' + agencyId;
        return this.http.delete(xUrl);
    }
    saveAgency(agency: AgencyDto): Observable<any> {
        let xUrl = this.myUrl + '/agency';
        if (agency.id.length < 1 ) {
            return this.http.post(xUrl, agency);
        }
        else {
            xUrl = xUrl + '/' + agency.id;
            return this.http.put(xUrl, agency);
        }
    }
    findAgency(agencyName: string): Observable<IAgency[]> {
        const xUrl = this.myUrl + '/agency/name/' + agencyName;
        return this.http.get<IAgency[]>(xUrl);
    }
    // End of Agency-related methods

    // Assessor-related methods
    saveAssessor(assessor: ApplicationAssessorDto): Observable<any> {
        const xUrl = this.myUrl + '/assessor';
        return this.http.put(xUrl, assessor);
    }

    // update Property Usecode, from Assessor module/tab
    // NOTE:    there is a problem with this API, i.e. it doesn't accept useCode values w/ slashes; encoding the URI does NOT help
    //          we should convert API to get useCode from the body (or from parameters)!
    //          THIS PROBLEM ALSO EXISTS IN THE LEGACY APP - as of 6/9/2020
    saveAssessorUsecode(applicationId: string, useCode: string): Observable<any> {
        const myUseCode = encodeURIComponent(useCode);    // need to encode useCode coz it may contain non-alphanumeric chars, i.e. "/"
        const parms = new HttpParams();
        parms.set('useCode', encodeURIComponent(useCode));

        const xUrl = this.myUrl + '/application/' + applicationId + '/property/useCode/' + myUseCode;
        return this.http.put(xUrl, { useCode });
        // return this.http.put(xUrl, { body }, { params: parms });
    }
    // End of Assessor-related methods

    // Minutes-related methods

    // get Minutes for specified ApplicationID and HearingID
    getHearingMinutes(applicationId: string, hearingId: string): Observable<ApplicationMinutesDto> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/hearing/' + hearingId + '/minutes';
        return this.http.get<ApplicationMinutesDto>(xUrl);
    }

    // save Minutes for specified ApplicationID and HearingID
    saveHearingMinutes(minutes: ApplicationMinutesDto): Observable<any> {
        // application/hearing
        let xUrl = this.myUrl + '/application/';
        if (minutes.id < 1) {
            // {applicationId}/hearing/{hearingId}/minutes
            return this.http.post(xUrl + minutes.applicationId + '/hearing/' + minutes.hearingId + '/minutes', minutes);
        }
        else {
            xUrl = xUrl + 'hearing/minutes/' + minutes.id;
            return this.http.put(xUrl, minutes);
        }

    }

    // save Batch of Minutes (from Agenda module)
    saveBatchHearingMinutes(minutes: any): Observable<any> {
        // {"applicationIds":[1,2],"hearingId":1,"minutesNote":"sample string 2"}
        const xUrl = this.myUrl + '/application/batch/minutes';
        return this.http.post(xUrl, minutes);

    }

    // DELETE Minutes for specified ApplicationID and Heading ID
    deleteHearingMinutes(applicationId: string, hearingId: string): Observable<any> {
        const xUrl = this.myUrl + '/application/' + applicationId + '/hearing/' + hearingId + '/minutes';
        return this.http.delete(xUrl);
    }
    // End of Minutes-related methods

    // APN/Unsecured Property-related methods
    findAPN(apn: string, rollYear: string): Observable<any> {
      const xUrl = this.myUrl + '/property/apn/' + apn + '/year/' + rollYear;
      return this.http.get(xUrl);
    }
    getUnsecuredValues(unsecNum: string, rollYear: string): Observable<any> {
      const xUrl = this.myUrl + '/property/unx/propnum/' + unsecNum + '/year/' + rollYear;
      return this.http.get(xUrl);
    }
    // End of APN/Property-related methods
    //
    // Miscellaneous methods
    // End of Miscellaneous methods

  private handleError(err: HttpErrorResponse) {
        // in a real world app, we may send the error to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage = '';
        const status = err.status;
        if (err.error instanceof Error) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
        }
        console.error(errorMessage);
        return Observable.throw(status);
    }

}
